import * as uri from '../config/uri';

export function isCategory(path) {
  return path.indexOf('/category') !== -1;
}

export function isItem(path) {
  return path.indexOf('/item') !== -1;
}
export function isCheckout(path) {
  return path.indexOf('/checkout') !== -1;
}
export function isRefinePathOpenMobile(path) {
  return path.indexOf('/filter') !== -1;
}
export function isSearchResult(path) {
  return path.indexOf('/search') !== -1;
}

export function isOldSearchResult(path) {
  return path.indexOf('/1_search') !== -1;
}

export function isSuggestionPage(path) {
  return path.indexOf('/suggestions') !== -1;
}
export function isMainPage(pathWithSlash) {
  const path = removeTrailingSlash(pathWithSlash);
  return path === removeTrailingSlash(uri.rootPageUri)
    || path === removeTrailingSlash(uri.dposRootPageUri)
    || path === removeTrailingSlash(uri.kioskRootPageUri)
    || path === removeTrailingSlash(uri.selfServiceKioskModePageUri)
    || path === removeTrailingSlash(uri.mainBoardModePageUri);
}

export function removeTrailingSlash(uri) {
  return uri.replace(/\/$/, '');
}

export function isProductsPage(path) {
  if (isMainPage(path)) {
    return true;
  }
  if (isCategory(path) && !isItem(path)) {
    return true;
  }

  if (isOldSearchResult(path) || isSearchResult(path)) {
    return true;
  }

  return false;
}

export function isSearchPage(pathWithSlash) {
  const path = removeTrailingSlash(pathWithSlash);
  if (path === removeTrailingSlash(uri.rootPageUri) 
    || path === removeTrailingSlash(uri.dposRootPageUri)
    || path === removeTrailingSlash(uri.kioskRootPageUri)
    || path === removeTrailingSlash(uri.selfServiceKioskModePageUri)
    || path === removeTrailingSlash(uri.mainBoardModePageUri)) {
    return true;
  }
  if (isCategory(path) && !isItem(path)) {
    return true;
  }
 
  return path.indexOf('/search') !== -1;
}

export const getQueryParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  let paramObj = {};
  for(var value of params.keys()) {
      paramObj[value] = params.get(value);
  }

  return paramObj;
}


// WEBPACK FOOTER //
// ./src/helpers/urlParts.js